import { useQuery, UseQueryResult } from "react-query";
import { capitalize } from "../utils/capitalize";
import { Role } from "./types";
import { get } from "./api";

export default function useGetRoles(): UseQueryResult<Role[]> {
  return useQuery("roles", () => getRoles());
}

export function useGetRolesDropdown() {
  const query = useGetRoles();

  const roles = query.data?.reduce((acc, role) => {
    return {
      ...acc,
      [capitalize(role.name)]: {
        value: role.name,
        disabled: false,
        ...getRoleProperties(role.name),
      },
    };
  }, {});

  return { ...query, data: roles };
}

function getRoleProperties(roleName: string) {
  switch (roleName) {
    case "admin":
      return { tooltip: "Allows user and billing management" };
    // case "member":
    //   return { tooltip: "Allows all other actions" };
    default:
      return {};
  }
}

async function getRoles(): Promise<Role[]> {
  const response = await get("roles");

  if (!response.ok) throw response.error;

  return response.data;
}
